module.exports = __webpack_public_path__ + "img/paraplume.d519e217.jpg";